interface ToastDescriptor
{
	body: Array<HTMLElement|JQuery<HTMLElement>|Text|string>;
	position?: number;
	timeout?: number;
	context?: ui.Context;
}

interface NotifyDescriptor extends ToastDescriptor
{
	title: Array<HTMLElement|JQuery<HTMLElement>|Text|string>;
}

class ToastPlane
{
	private	plane: HTMLElement;
	private element: JQuery;
	private	close: JQuery;
	private timeout: number|null;

	constructor()
	{
		this.plane = document.createElement( 'toast-plane' );

		$( document.body ).append( this.plane );
		this.element = $( document.createElement( 'notify' ) );
		this.close = $( document.createElement( 'button' ) );
		this.timeout = null;
	}

	public addToast( descriptor: ToastDescriptor )
	{
		this.createBox( descriptor );

		this.buildBox( descriptor );
	}

	public addNotify( descriptor: NotifyDescriptor )
	{
		this.createBox( descriptor );

		const head = $( document.createElement( 'toast-plane-head' ) );
		for ( const i in descriptor.title )
		{
			head.append( descriptor.title[ i ] );
		}
		this.element.append( head );

		this.element.append( ui.$$.hr );

		this.buildBox( descriptor );
	}

	public remBox( element: JQuery )
	{
		$(this.plane).attr('style', 'z-index:-1');
		this.element.remove();
	}

	private createBox( descriptor: ToastDescriptor )
	{
		$(this.plane).attr('style', 'z-index:99999');

		if ( descriptor.context )
		{
			$( this.element ).addClass( 'bg-' + descriptor.context );
		}

		if ( descriptor.timeout )
		{
			this.timeout = setTimeout( () => this.remBox( this.element ), descriptor.timeout );
		}

		$( this.element ).on(
			{
				mouseenter: () =>
				{
					try
					{
						if ( this.timeout !== null )
						{
							clearTimeout( this.timeout );
						}
					} catch (_) {}
				},
				mouseleave: () =>
				{
					this.timeout = setTimeout( () => this.remBox( this.element ), descriptor.timeout );
				},
			},
		);

		this.closeButton();
	}

	private buildBox( descriptor: ToastDescriptor )
	{
		const body = $( document.createElement( 'toast-plane-body' ) );
		for ( const i in descriptor.body )
		{
			body.append( descriptor.body[ i ] );
		}
		this.element.append( body );

		this.element.appendTo(this.plane);
	}

	private closeButton()
	{
		this.close.attr( 'type', 'button' );
		this.close.addClass( 'close' );
		this.close.attr( 'aria-label', 'Close' );
		this.close.html( '&times;' );

		this.close.on( 'click', () => { this.remBox( this.element ); } );

		this.close.appendTo(this.element);
	}

}
